import 'bootstrap/dist/css/bootstrap.min.css';

// 🎨 디자인 시스템 (@bnvsrnd/brand-assets) — 토큰 + 컴포넌트 스타일
import '@bnvsrnd/brand-assets/tokens/light.css';
import '@bnvsrnd/brand-assets/tokens/dark.css';
import '@bnvsrnd/brand-assets/styles.css';
import './styles/brand/brand-override.css'; // DuoTutor 퍼플 brand override (토큰 다음)

// 🚀 FontAwesome Tree Shaking: 전체 CSS 제거, SVG 아이콘만 사용
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/utilities.css';
import './styles/tailwind.css'; // tw- 유틸 (preflight off, Bootstrap 공존)
import App from './App';
import './styles/common/modal.css';

// ⚠️ Bridge 는 반드시 마지막: 레거시 + Bootstrap CSS 변수를 디자인 시스템 토큰으로 최종 매핑
import './styles/brand/bridge.css';

// 페이지 max-width 통일 — admin.css/responsive.css 의 .container 오버라이드를 이기려면
// 반드시 그 뒤(맨 마지막)에서 !important 로 단일 권위 선언.
import './styles/layout.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
// NOTE: StrictMode 는 dev 에서 모든 컴포넌트를 2번 렌더·마운트(effect 2회)하여
// 페이지 전환 시 새 페이지 렌더가 길어져 "이전 화면이 잠깐 남는" 체감을 키운다.
// (프로덕션 빌드엔 영향 없음) 개발 체감 개선을 위해 해제. 버그 점검 시 다시 감싸면 됨.
root.render(<App />);
